module.exports = __webpack_public_path__ + "img/icon-google.e381f4dd.png";